import { render, staticRenderFns } from "./departmentmanagement.vue?vue&type=template&id=527d9987&scoped=true&"
import script from "./departmentmanagement.vue?vue&type=script&lang=js&"
export * from "./departmentmanagement.vue?vue&type=script&lang=js&"
import style0 from "./departmentmanagement.vue?vue&type=style&index=0&id=527d9987&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527d9987",
  null
  
)

export default component.exports